import { ReactNode } from "react";
import { ItemWithMetaData } from "../api/Items";
import Button, {
  ButtonColorTypes,
  ButtonTypes,
} from "../shared-components/Button";
import { SocialIcon } from "../utils/social-icon";
import { MatchingEntitiesConfirm } from "./ProfileRowConfirm";
import ReactTooltip from "react-tooltip";

type SuggestedProfilesProps = {
  suggestedProfiles: ItemWithMetaData[];
  tabColor?: string;
  onDelete?: () => void;
  className?: string;
  children?: ReactNode;
  isManualAdd?: boolean;
  isReadOnly?: boolean;
  handleAddRating?: (itemUUID: string) => void;
};

const SuggestedProfiles = ({
  suggestedProfiles,
  isReadOnly,
  handleAddRating,
}: SuggestedProfilesProps) => {
  return (
    <div className="">
      <span className="text-2xl font-semibold pb-8">Suggested Profiles</span>
      <div className="bg-gray-50 shadow-sm rounded-lg p-4 border border-gray-200 mt-6">
        <div className="">
          {suggestedProfiles.length === 0 && (
            <div className="">No Suggested Profiles Found</div>
          )}
        </div>

        {suggestedProfiles?.map((profile) => (
          <div
            key={profile.item.external_id}
            className="mt-2 rounded-lg p-3 border border-gray-300 bg-white"
          >
            <div className="flex justify-between items-center">
              <div className="flex items-center overflow-hidden">
                <div className="w-19">
                  <SocialIcon url={profile.item.content.url} />
                </div>
                <a
                  href={profile.item.content.url}
                  target="_blank"
                  rel="noreferrer"
                  className="ml-3 text-base font-normal leading-6 truncate"
                  data-tip={profile.item.content.url}
                >
                  {profile.item.content.url}
                </a>
                <ReactTooltip
                  className="hover:visible:opacity-1 w-96"
                  delayHide={1000}
                  effect="solid"
                />
              </div>
              {!isReadOnly && (
                <Button
                  text="Add"
                  type={ButtonTypes.add}
                  colorType={ButtonColorTypes.cancel}
                  onClick={() => handleAddRating?.(profile.item.external_id)}
                />
              )}
            </div>
            <div className="pl-20">
              <MatchingEntitiesConfirm item={profile} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuggestedProfiles;
